

import { classesRuntime, statesRuntime } from "./../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_220_3_opacity";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_220_3_opacity__root"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"opacity06":"rgba(255, 255, 255, 0.06)","opacity12":"rgba(255, 255, 255, 0.12)","opacity18":"rgba(255, 255, 255, 0.18)","opacity24":"rgba(255, 255, 255, 0.24)","opacity30":"rgba(255, 255, 255, 0.30)","opacity36":"rgba(255, 255, 255, 0.36)","opacity42":"rgba(255, 255, 255, 0.42)","opacity48":"rgba(255, 255, 255, 0.48)","opacity66":"rgba(255, 255, 255, 0.66)","opacity90":"rgba(255, 255, 255, 0.90)","opacity96":"rgba(255, 255, 255, 0.96)"}; 
export var vars = {}; 




